import React from "react";
import {
  Bar,
  Title,
  BackIcon,
  RightIcon,
  TopBgImage,
} from "./Topbar.style";

const Topbar = ({
  title,
  rightIcon = "",
  transparent = false,
  showLeftIcon = true,
  goBack,
}) => {
  // transparent

  return (
    <>
      <Bar id="top-bar" bg={transparent ? "transparent" : "filled"}>
        {showLeftIcon && <BackIcon onClick={() => goBack()} />}
        <Title>{title}</Title>
        {rightIcon && <RightIcon>{rightIcon}</RightIcon>}
      </Bar>
      {transparent && <TopBgImage />}
    </>
  );
};

export default Topbar;
